import { render, staticRenderFns } from "./layoutProfileMenu.vue?vue&type=template&id=52754cdb&"
import script from "./layoutProfileMenu.vue?vue&type=script&lang=js&"
export * from "./layoutProfileMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports